import React from 'react';
import './styles/BoardButton.css';

const BoardButton = ({ onClick, label, style, className, disabled }) => {
    return (
        <button className={className} id='button' style={style} onClick={disabled ? undefined : onClick} disabled={disabled}>
            {label}
        </button>
    );
};

export default BoardButton;